!function() {
  "use strict";
  const e = "[data-collection-sidebar]",
        t = "[data-collection-sidebar-slide-out]",
        i = "[data-collection-sidebar-close]",
        s = "[data-aria-toggle]",
        o = "drawer--animated",
        l = "expanded",
        n = "no-mobile-animation",
        c = "is-focused";
  
  if (!customElements.get("collection-component")) {
    customElements.define("collection-component", class extends HTMLElement {
      constructor() {
        super();
        this.collectionSidebar = this.querySelector(e);
        this.groupTagsButton = this.querySelector(s);
        this.a11y = window.theme.a11y;
        this.groupTagsButtonClickEvent = event => this.groupTagsButtonClick(event);
        this.sidebarResizeEvent = () => this.toggleSidebarSlider();
        this.collectionSidebarCloseEvent = event => this.collectionSidebarClose(event);
      }
      
      connectedCallback() {
        if (this.groupTagsButton !== null) {
          document.addEventListener("theme:resize:width", this.sidebarResizeEvent);
          this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent);
          
          if (this.collectionSidebar) {
            setTimeout(() => {
              this.collectionSidebar.classList.remove(n);
            }, 1000);
          }
          
          new MutationObserver(mutations => {
            for (const mutation of mutations) {
              if (mutation.type === "attributes") {
                if (mutation.target.getAttribute("aria-expanded") === "true") {
                  this.showSidebarCallback();
                }
              }
            }
          }).observe(this.groupTagsButton, { attributes: true, childList: false, subtree: false });
        }
        
        this.addEventListener("keyup", event => {
          if (event.code === "Escape") {
            this.hideSidebar();
          }
        });
        
        if (this.collectionSidebar) {
          this.collectionSidebar.addEventListener("transitionend", () => {
            if (!this.collectionSidebar.classList.contains(l)) {
              this.collectionSidebar.classList.remove(o);
            }
          });
          this.toggleSidebarSlider();
          this.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
        }
      }
      
      showSidebarCallback() {
        const slideOutElem = this.querySelector(t),
              scrollLocked = document.documentElement.hasAttribute("data-scroll-locked"),
              isMobile = window.theme.isMobile();
        
        this.collectionSidebar.classList.add(o);
        
        if (slideOutElem === null && !isMobile && scrollLocked) {
          this.a11y.removeTrapFocus();
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
        
        if (isMobile || slideOutElem !== null) {
          if (slideOutElem) {
            this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(i) });
          }
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
        }
      }
      
      hideSidebar() {
        const slideOutElem = this.querySelector(t),
              scrollLocked = document.documentElement.hasAttribute("data-scroll-locked");
        
        if (this.groupTagsButton) {
          this.groupTagsButton.setAttribute("aria-expanded", "false");
        }
        
        this.collectionSidebar.classList.remove(l);
        if (slideOutElem) {
          this.a11y.removeTrapFocus();
        }
        if (scrollLocked) {
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
      }
      
      toggleSidebarSlider() {
        window.theme.isMobile() ? this.hideSidebar() :
          (this.collectionSidebar.classList.contains(l) && this.showSidebarCallback());
      }
      
      collectionSidebarClose(event) {
        event.preventDefault();
        this.hideSidebar();
        if (document.body.classList.contains(c) && this.groupTagsButton) {
          this.groupTagsButton.focus();
        }
      }
      
      groupTagsButtonClick() {
        if (document.documentElement.hasAttribute("data-scroll-locked")) {
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
      }
      
      disconnectedCallback() {
        if (this.groupTagsButton !== null) {
          document.removeEventListener("theme:resize:width", this.sidebarResizeEvent);
          this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent);
        }
        if (this.collectionSidebar) {
          this.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
        }
      }
    });
  }
}();